<template>
  <div v-if="structure !== 'unknown'">
    <Table
      :headers="processedData.headers"
      :rows="processedData.rows"
      :grid-template-columns="gridTemplateColumns"
      :highlighted-columns="[]"
      :highlight-style="highlightStyle" />
  </div>
  <div v-else>
    <h2 v-if="title">title = {{ title }}</h2>
    <p>structure = {{ structure }}</p>
    <!-- <p>columns = {{ JSON.stringify(columns, null, 2) }}</p> -->
    <!-- <p>headers = {{ JSON.stringify(headers, null, 2) }}</p> -->
    <pre>data = {{ JSON.stringify(data, null, 2) }}</pre>
    <!-- <p>rows = {{ JSON.stringify(rows, null, 2) }}</p> -->
  </div>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
const props = defineProps(["title", "data", "abbreviations", "currency"]);
import {computed} from "vue";
import Table from "@/components/App/Table";
import {useShort} from "@/composables/useShort";
import history from "@/assets/history.json";
// import {useDataTransition} from "@/composables/useDataTransition";
const validData = props.data && typeof props.data === "object";
const validTitle = props.title && typeof props.title === "string";
const structure = computed(() => {
  if (!validData || !validTitle) return "unknown";
  const firstValue = Object.values(props.data)[0];
  if (typeof firstValue === "number" || typeof firstValue === "string") return "simple";
  if (typeof firstValue === "object" && !Array.isArray(firstValue)) return "nested";
  return "unknown";
});
// const {intermediateData} = useDataTransition(() => props.data);
const $ = (number) => `${props.currency || history.currency}${number}`;
const {short} = useShort(props.abbreviations);
const highlightStyle = {
  "background-color": "#cfcfcf",
  color: "black",
  "border-radius": "0px",
  transition: "background-color 0.3s ease, color 0.3s ease"
};

const processedData = computed(() => {
  if (!validData || !validTitle) return {headers: [], rows: []};

  const firstKey = Object.keys(props.data)[0];
  const firstValue = props.data[firstKey];

  // Case 1: Simple key-value pairs (numbers OR strings)
  if (typeof firstValue === "number" || typeof firstValue === "string") {
    return {
      headers: [props.title, ""],
      rows: Object.entries(props.data).map(([key, value]) => [
        short(key),
        typeof value === "number" ? `${$(value)}` : `${value}`
      ])
    };
  }

  // Case 2: Nested key-value pairs
  if (typeof firstValue === "object" && !Array.isArray(firstValue)) {
    const headers = Object.keys(props.data);

    const categories = Array.from(
      new Set(headers.flatMap((col) => Object.keys(props.data[col] || {})))
    );

    const shortHeaders = headers.map((header) => short(header));

    return {
      headers: [short(props.title), ...shortHeaders],
      rows: categories.map((category) => [
        short(category),
        ...headers.map((col) => $(props.data[col]?.[category]) ?? "N/A")
      ])
    };
  }

  return {headers: [], rows: []};
});

const gridTemplateColumns = computed(() => {
  if (processedData.value.headers.length === 2) return "2fr 1fr"; // First column is twice as wide as the second
  return null; // Default to evenly spaced columns
});
</script>

<style scoped>
pre {
  background-color: #cfcfcf; /* totally not needed; just here to help choose color */
}
</style>
